<template>
  <div class="export-import">
    <!-- <div class="field has-addons"> -->
    <p class="buttons import-export-btn">
      <a @click="export_geojson($event)" class="button is-medium-16-500-19">
        <span class="icon">
          <i class="fas fa-file-export"></i>
        </span>
        <a class="has-text-black btn-text">Export</a>
      </a>
      <a
        @click="isModalActive = true"
        class="button is-medium-16-500-19 import-btn"
      >
        <span class="icon">
          <i class="fas fa-file-import"></i>
        </span>
        <span class="has-text-black btn-text">Import</span>
      </a>
      <!-- <a class="button is-medium-16-500-19 import-btn">
          <span class="icon">
            <i class="fa fa-save"></i>
          </span>
          <span class="has-text-black btn-text">Save</span>
        </a> -->
    </p>
    <!-- </div> -->
    <b-modal class="import-container" :width="515" :active.sync="isModalActive">
      <div class="card import-file" style="border-radius: 10px">
        <!-- <div class="card-header project-import">
          <div class="card-header-title is-capitalized is-semibold-18-600-22 modal-title ">Import</div>
        </div> -->
        <div class="card-content">
          <section>
            <b-field>
              <b-upload v-model="dropFiles" multiple drag-drop>
                <section class="section">
                  <div class="content has-text-centered">
                    <p>
                      <b-icon icon="upload" size="is-large"></b-icon>
                    </p>
                    <p>Drop your files here or click to upload</p>
                  </div>
                </section>
              </b-upload>
            </b-field>
            <div class="tags">
              <span
                v-for="(file, index) in dropFiles"
                :key="index"
                class="tag is-primary"
              >
                {{ file.name }}
                <button
                  class="delete is-small"
                  type="button"
                  @click="delete_drop_file(index)"
                ></button>
              </span>
            </div>
            <b-checkbox v-model="use_all_properties">Use all properties</b-checkbox>
            <div>
              <a @click="import_geojson($event)" class="button is-info">
                <span class="icon">
                  <i class="fa fa-save"></i>
                </span>
                <span class="button__label">Submit</span>
              </a>
            </div>
          </section>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      dropFiles: [],
      imported_features: [],
      isModalActive: false,
      use_all_properties:false
    };
  },
  computed: {
    ...mapGetters(["draw"]),
  },
  created() {
    if(location.origin.includes("sdp"))
        this.use_all_properties = true
  },
  methods: {
    validate_features(features) {
      if (!features) return [];
      function getArrayDepth(obj) {
        if (Array.isArray(obj))
          return 1 + Math.max(...obj.map((t) => getArrayDepth(t)));
        else return 0;
      }
      let new_features = features.reduce((acc, c) => {
        // let new_feature = _.cloneDeep(feature);
        let new_feature = c;
        let allowed_depth = 0;
        if (new_feature.geometry.type == "MultiPolygon") {
          allowed_depth = 3;
          new_feature.geometry.type = "Polygon";
        } else if (
          new_feature.geometry.type == "MultiLineString" ||
          new_feature.geometry.type == "PolyLine"
        ) {
          allowed_depth = 2;
          new_feature.geometry.type = "LineString";
        }
        let depth = getArrayDepth(new_feature.geometry.coordinates);
        while (allowed_depth && depth > allowed_depth) {
          new_feature.geometry.coordinates =
            new_feature.geometry.coordinates[0];
          depth = getArrayDepth(new_feature.geometry.coordinates);
        }
        if (depth === 3) {
          new_feature.geometry.coordinates[0] =
            new_feature.geometry.coordinates[0].map((a) => a.slice(0, 2));
        } else if (depth === 2) {
          new_feature.geometry.coordinates =
            new_feature.geometry.coordinates.map((a) => a.slice(0, 2));
        }

        if (
          (new_feature.geometry.type === "Polygon" &&
            new_feature.geometry.coordinates[0].length < 4) ||
          (new_feature.geometry.type === "LineString" &&
            new_feature.geometry.coordinates[0].length < 2)
        )
          return acc;
        // parsing raw images objects
        if (
          new_feature.properties &&
          new_feature.properties.raw_images &&
          new_feature.properties.raw_images.length
        ) {
          new_feature.properties.raw_images =
            new_feature.properties.raw_images.map((r) =>
              r && _.isString(r) ? JSON.parse(r) : r
            );
        }
        acc.push(new_feature);
        return acc;
      }, []);

      return new_features;
    },
    readFile(file) {
      var reader = new FileReader();
      return new Promise((resolve, reject) => {
        reader.onload = (e) => {
          let json = JSON.parse(reader.result);
          if (!json || !json.features) reject();
          this.imported_features.push(...json.features);
          resolve();
        };
        reader.readAsText(file, "UTF-8");
      });
    },
    delete_drop_file(index) {
      this.dropFiles.splice(index, 1);
    },
    async import_geojson(event) {
      try {
        this.imported_features = [];
        for (var i = 0; i < this.dropFiles.length; i++) {
          await this.readFile(this.dropFiles[i]);
        }
        let valid_features =
          this.$route.name === "therm"
            ? this.validate_features(this.imported_features)
            : this.imported_features;

        let invalid_features =
          this.imported_features.length - valid_features.length;
        if (invalid_features) {
          alert(`${invalid_features} features are invalid.`);
        }


       
          valid_features = valid_features.map(feature=>{
            let f = _.cloneDeep(feature);
            let extra_props;
            try {
              if(_.isString(f.properties.extraProperties))
                   extra_props = JSON.parse(f.properties.extraProperties)
              else extra_props = f.properties.extraProperties
            } catch(e) {
              extra_props = {}
            }
              
            let properties = {
              extraProperties:{...(extra_props || {})}
            };
            Object.keys(f.properties).forEach(key=>{
              if(key.startsWith("$")){
                properties.extraProperties[key.replace("$", "")] = f.properties[key];
              } 
              else if(key.startsWith("custom_")){
                properties.extraProperties[key.replace("custom_", "")] = f.properties[key];
              } else if(this.use_all_properties && key!=="name") {
                properties.extraProperties[key] =  f.properties[key];
              } else if(key!=="extraProperties")  {
                properties[key] =  f.properties[key];
              }
            })
            f.properties = properties;
            return f;
           })
        
           console.log({valid_features})

        this.draw.add({
          type: "FeatureCollection",
          features: valid_features,
        });
        this.$store.state.map.flyTo({
          center: turf.centroid(valid_features[0]).geometry.coordinates,
          zoom: 18,
          speed: 2.5,
        });

        this.isModalActive = !this.isModalActive;
      } catch (err) {
        alert("processing error...");
      }
    },
    export_geojson($event) {
      const filename = "data.json";

      const fc = this.draw.getAll()
      fc.features = fc.features.map(f => {
        Object.keys(f.properties.extraProperties||{}).forEach(key => {
          f.properties[`$${key}`] = f.properties.extraProperties[key];
        })
        return f;
      })

      const jsonStr = JSON.stringify(fc);

      var jsonData = new Blob([jsonStr], { type: "text/json" });
      var csvUrl = URL.createObjectURL(jsonData);

      $event.target.setAttribute("href", csvUrl);
      $event.target.setAttribute("download", filename);
    },
  },
};
</script>
<style lang="scss" >
.import-btn {
  position: relative;
}
// .button-dropdown{
//   padding-top: 4px;
//   display: flex;
//   flex-direction: column;
//   border-radius: 6px;
//   position: absolute;
//   top: 2.7rem;
//   width: 150px;
//   z-index: 2;
//   .button {
//     text-align: left;
//     border: none !important;
//     box-shadow: none !important;
//   }
//   .button:hover {
//     background: #f4f7fc;
//   }
// }
.export-import {
  display: flex;
  justify-content: center;
  margin: 1rem auto 0.5rem auto;
  .import-file {
    .project-import {
      .button {
        margin-top: 0.5rem;
      }
    }
  }
  .import-export-btn {
    margin-top: 0.8rem;
    .button {
      padding: 1.3rem 2.3rem;
      border-radius: 6px;
      border: solid 1px rgba(23, 30, 72, 0.3);
      box-shadow: 0 1px 3px 0 rgba(23, 30, 72, 0.1);
    }
    .button .icon {
      margin-right: 0.4rem;
    }
  }
  .import-file {
    padding: 20px;
    width: 100%;
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    justify-content: center;
    background: white;
  }
  @media screen and (min-width: 769px) {
    .modal .animation-content {
      width: 400px;
    }
  }
}

.import-container .card {
  background-color: #f4f7fc;
  .card-header {
    background-color: #fff;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
  }
  .card-content {
    margin-top: 1rem;
    overflow: scroll;
  }
  .card-content .select-title {
    font-family: Barlow-medium;
    font-size: 14px;
    font-weight: 500;
    text-align: left;
    color: #171e48;
    margin-bottom: 0;
  }
  .card-content .import {
    width: 108px;
    height: 50px;
    border-radius: 6px;
    background-color: #5c7ef7;
    margin-top: 0.8rem;
    margin-bottom: 1.5rem;
  }
}

.upload .upload-draggable {
  display: block;
  margin-top: 1rem;
  border-radius: 10px;
}
.source-srs {
  margin-top: 0.5rem;
  border-radius: 6px;
}
.source-dropdown .input {
  border: none;
  height: 56px;
  border-radius: 6px;
  box-shadow: 0 2px 4px 0 rgba(23, 30, 72, 0.07);
  background-color: #ffffff;
  font-size: 16px;
}
</style>

